<template>
  <div class="container">
    <div class="search">
      <Search shape="round" placeholder="请搜索关键字" disabled @click="handleClickGoPageBaseSearch" />
    </div>
    <div class="search-list">
      <div
        v-for="(item,index) in SearchTiyleList"
        :key="index"
        @click="handleGopageSearchDetails(item.id)"
      >{{item.title}}</div>
    </div>
  </div>
</template>
<script>
import { Search } from "vant";
import { SeacrhList } from "@/api/knowledgeBase";
export default {
  components: {
    Search
  },
  data() {
    return {
      activeName: "2",
      SearchTiyleList: []
    };
  },
  mounted() {
    this.requestSeacrhList();
  },
  methods: {
    // 常见问题列表
    requestSeacrhList() {
      let typeIndex = this.typeIndex;
      let keyWord = this.keyWord;
      SeacrhList({ titleOrContent: keyWord }).then(res => {
        console.log(res);
        this.SearchTiyleList = res.data;
      });
    },
   handleGopageSearchDetails(id) {
      this.$router.push({
        path: "/basesearchdetails",
        query: {
          id: id
        }
      });
    },
    handleClickGoPageBaseSearch() {
      this.$router.push({
        path: "/baseserch",
      });  
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100%;
  background-color: #f6f6f6;
  overflow-x: hidden;
  .search {
    width: 100%;
    height: 51px;
    background-color: #ffffff;
  }
  .search-list {
    width: 100%;
    min-height: 100%;
    background-color: #ffffff;
    text-align: left;
    padding: 0 15px;
    box-sizing: border-box;
    font-size: 15px;
    margin-top: 10px;
    div {
      width: 100%;
      height: 50px;
      line-height: 50px;
      border-bottom: 1px solid #f2f2f2;
      background-color: #ffffff;
      text-align: left;
      font-size: 15px;
    }
  }
}
</style>
<style lang="scss">
.van-cell__title {
  text-align: left;
}
.van-collapse-item__content {
  text-align: left;
}
</style>